interface LeaveStatusPayload {
    eventType: 'approved' | 'rejected';
    leaveId: string;
    title: string;
    userName: string;
    userEmail: string;
    startDate: string;
    endDate: string;
    allDay: boolean;
    totalDuration: number;
    commentByRrhh?: string;
    approverEmail?: string;
}

export const sendLeaveStatusToN8n = async (
    eventType: 'approved' | 'rejected',
    leaveId: string,
    title: string,
    userName: string,
    userEmail: string,
    startDate: string,
    endDate: string,
    allDay: boolean,
    totalDuration: number,
    commentByRrhh?: string,
    approverEmail?: string,
): Promise<{ success: boolean; error?: string }> => {
    const N8N_WEBHOOK_URL = import.meta.env.VITE_N8N_WEBHOOK_LEAVE_STATUS_URL;

    if (!N8N_WEBHOOK_URL) {
        return { success: false, error: 'Webhook URL no configurada' };
    }

    try {
        const payload: LeaveStatusPayload = {
            eventType,
            leaveId,
            title,
            userName,
            userEmail,
            startDate,
            endDate,
            allDay,
            totalDuration,
            commentByRrhh,
            approverEmail,
        };

        const response = await fetch(N8N_WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            console.error('Error n8n:', response.status);
            return { success: false, error: `HTTP ${response.status}` };
        }

        return { success: true };

    } catch (error) {
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido'
        };
    }
};